<template>
  <span class="ant-custom-label" :class="class" :style="style" :width="width">
    {{ labelTitle }}
    <span v-if="isRequired "/>
  </span>
</template>
<script>


export default {
  name: 'FormLabel',
  props: {
    labelTitle: {
      type: String,
      required: true,
    },
    class: {
      type: String,
      required: false,
    },
    style: {
      type: String,
      required: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      required: false,
      default: '110px',
    },
  },
}
</script>
<style scoped lang="scss">
.ant-custom-label {
  height: 40px;
  margin-bottom: 0px;
  margin-left: 0px;
  display: flex;
  align-items: center;
  gap: 3px;
  color: #2F3337;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;

  span {
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: #FB574B;
    border-radius: 100%;
    margin-bottom: 10px;
  }
}

.customPlaceholder::placeholder {
  font-size: 15px;
  color: #c0c0c0;
}
</style>